<template>
  <div>
    <div style="margin-top: 20px;">
      <el-button icon="el-icon-plus" type="primary" @click="addluck"
        >添加抽奖
      </el-button>
      <el-button type="primary" @click="qrcode">抽奖二维码</el-button>
      <el-button type="primary" @click="IsWrite_off = true">中奖核销</el-button>
    </div>
    <el-tabs style="margin-top: 20px;" type="border-card" @tab-click="tabClick">
      <el-tab-pane label="活动列表">
        <el-table :data="luckData" style="width: 100%">
          <!-- <el-table-column prop="id" label="ID" width="100"> </el-table-column> -->
          <el-table-column label="活动标题" prop="prize_name">
            <template slot-scope="scope">
              <a
                style="color: #23A8F2;cursor:pointer;"
                @click="statistics(scope.row)"
                >{{ scope.row.prize_name }}</a
              >
            </template>
          </el-table-column>
          <el-table-column label="开始时间" prop="start_time">
          </el-table-column>
          <el-table-column label="结束时间" prop="end_time"></el-table-column>
          <el-table-column label="活动状态" prop="luck_status">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.luck_status == 0
                    ? 'success'
                    : scope.row.luck_status == 1
                    ? 'info'
                    : 'danger'
                "
                v-text="
                  scope.row.luck_status == 0
                    ? '进行中'
                    : scope.row.luck_status == 1
                    ? '未开始'
                    : '已结束'
                "
              ></el-tag>
            </template>
          </el-table-column>
          <el-table-column label="活动标语" prop="slogan"></el-table-column>
          <el-table-column label="开启/关闭" prop="slogan">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status == 1 ? 'success' : 'danger'"
                v-text="scope.row.status == 1 ? '启用' : '禁用'"
              ></el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="350">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="text"
                @click="Winninglist(scope.row)"
                >中奖列表
              </el-button>
              <el-button
                size="small"
                type="text"
                @click="statistics(scope.row, 1)"
                >活动统计
              </el-button>
              <el-button
                :disabled="scope.row.luck_status !== 1"
                size="small"
                type="primary"
                @click="edit_lottery(scope.row)"
                >修改
              </el-button>
              <el-button
                :disabled="scope.row.luck_status !== 1"
                size="small"
                @click="del_lottery(scope.row)"
                >删除
              </el-button>
              <el-button
                :disabled="scope.row.luck_status == 2"
                :type="scope.row.status == 1 ? 'danger' : 'success'"
                size="small"
                @click="status(scope.row)"
                v-text="scope.row.status == 1 ? '禁用' : '启用'"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :page-size="pageSize"
          :total="total"
          background
          hide-on-single-page
          layout="prev, pager, next"
          style="float: right;margin-top: 20px;"
          @current-change="currentChange"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="IsWrite_off" :show-close="false" :close-on-click-modal="false" title="中奖核销" width="400px">
      <el-form label-width="auto">
        <el-form-item label="活动中奖单号">
          <el-input
            v-model="order_sn"
            placeholder="请输入需要核销的中奖单号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="(IsWrite_off = false), (order_sn = '')"
          >取 消
        </el-button>
        <el-button type="primary" @click="Write_off">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="Isewm"
      destroy-on-close
      title="抽奖二维码"
      width="250px"
    >
      <div id="qrcode" ref="qrcode" style="margin: 0;"></div>
    </el-dialog>
  </div>
</template>
<script>
import { consume, edit_status, lottery_del, luck_Data } from "@/api/vip";
import QRCode from "qrcodejs2";
import time from "@/utils/time";
import store from "@/store/index";

export default {
  data() {
    return {
      Isewm: false,
      IsWrite_off: false,
      order_sn: "",
      luckData: [],
      total: 0,
      page: 1,
      pageSize: 10
    };
  },
  mounted() {
    this.init();
  },
  watch: {},
  methods: {
    //添加活动
    addluck() {
      this.$store.dispatch("SETINIT");
      this.$router.push(
        "/apply/newVip/13/market/marketing/client/lottery/turntable"
      );
    },
    //二维码
    qrcode() {
      if (!this.luckData.find(x => x.status == 1))
        return this.$message("确保存在抽奖活动");
      this.Isewm = true;
      let id = this.luckData.find(x => x.status == 1).id;
      let test = "cskf";
      let onlie = "xzf";
      let storeage = localStorage.getItem("baseStatus");
      let url = `https://${
        storeage == "test" ? test : onlie
      }.58zltc.com/reward?app_id=${store.getters.app_id}&lottery=${id}`;
      console.log("id", url);
      this.$nextTick(() => {
        new QRCode("qrcode", {
          width: 200, // 设置宽度，单位像素
          height: 200, // 设置高度，单位像素
          text: url // 设置二维码内容或跳转地址
        });
      });
    },
    //核销
    Write_off() {
      // this.IsWrite_off = true;
      this.$confirm(`确定核销单号为: ${this.order_sn}的中奖记录`, "核销", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          consume({
            app_id: store.getters.app_id,
            order_sn: this.order_sn
          }).then(res => {
            if (res.code == 200) {
              this.$message.success(
                `单号为: ${this.order_sn}的中奖记录核销完成`
              );
              // this.get_winning_Data()
              this.IsWrite_off = false;
              this.order_sn = "";
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message("核销取消");
          this.IsWrite_off = false;
          this.order_sn = "";
        });
    },
    //初始化
    init() {
      this.get_luck_Data();
      // this.qrcode()
    },
    //分页
    currentChange(val) {
      this.page = val;
      this.get_luck_Data();
    },
    //中奖列表
    Winninglist(row) {
      this.$router.push({
        path: "/apply/newVip/13/market/marketing/client/lottery/winningList",
        query: {
          id: row.id
        }
      });
    },
    //获取抽奖列表
    async get_luck_Data() {
      try {
        const res = await luck_Data({
          app_id: store.getters.app_id
        });
        if (res.code == 200) {
          let arr = [];
          res.data.forEach(item => {
            if (time.isDuringDate(item.start_time, item.end_time) == 0) {
              item.luck_status = 0;
            } else if (time.isDuringDate(item.start_time, item.end_time) == 1) {
              item.luck_status = 1;
            } else {
              item.luck_status = 2;
            }
          });
          //res.data为全部数据，luckData是目前表格绑定的数据
          res.data = res.data.reverse();
          arr = res.data.slice(
            (this.page - 1) * this.pageSize,
            this.page * this.pageSize
          );
          // this.total = this.allData.length;
          this.total = res.data.length;
          // fruits.reverse();
          this.luckData = arr;
        }
      } catch (e) {
        console.log(e);
      }
    },

    //点击tabs触发
    tabClick(val) {
      if (val == "活动列表") {
        this.get_luck_Data();
      }
      if (val == "中奖列表") {
        this.get_winning_Data();
      }
    },
    //开启,禁用
    async status(i) {
      try {
        const Status = await edit_status({
          app_id: store.getters.app_id,
          id: i.id,
          status: i.status == 1 ? 0 : 1
        });
        if (Status.code == 200) {
          this.$message.success(Status.msg);
          this.init();
        }
      } catch (e) {
        console.log(e);
      }
    },
    //点击修改
    async edit_lottery(row) {
      try {
        this.$router.push({
          path: "/apply/newVip/13/market/marketing/client/lottery/turntable",
          query: {
            key: 1,
            id: row.id
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    //点击删除
    del_lottery(row) {
      this.$confirm("确定删除此活动?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          lottery_del({
            app_id: store.getters.app_id,
            id: row.id
          }).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.init();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message("删除取消");
        });
    },
    //活动统计
    statistics(row, key) {
      this.$router.push({
        path: "/apply/newVip/13/market/marketing/client/lottery/statistics",
        query: {
          id: row.id,
          key: key
        }
      });
    }
  }
};
</script>
